<template>
  <section class="layout-section -split">
    <section class="layout-section__content">
        <h2 class="layout-section__title">{{ $t('acupuncture.title') }}</h2>
        <p>{{ $t('acupuncture.content') }}</p>

        <a href="https://acupuncturelaflamme.com/" target="_blank" rel="noopener" class="link -icon -spacing">
          {{ $t('common.learnMore') }}
          <svg-icon id="arrow" />
        </a>
    </section>

    <figure class="layout-section__image" />
  </section>
</template>

<script>
export default {
  name: 'HomeAbout'
}
</script>
